import { useCompanyInformation, useProviderTokensAndSyncedProviders } from '@neo.tax/shared/hooks';
import { isTicketingTokenConnected } from '@neo.tax/shared/utils';

interface GettingStartedStatus {
  connectTicketingProviderComplete: boolean;
  companyInfoComplete: boolean;
  canStartAnalysis: boolean;
  loading: boolean;
}

/**
 * Hook to determine the status of the getting started tasks. This consolidates the
 * business logic for determining whether the getting started tasks are complete.
 */
export const useGettingStartedStatus = ({ fiscalYearId }: { fiscalYearId: string }): GettingStartedStatus => {
  const {
    companyInformation: { elevatorPitch, fiscalYearEndMonth },
    loading: isUseCurrentCompanyLoading,
  } = useCompanyInformation();
  const { loading: isUseProviderTokensAndSyncedProvidersLoading, ticketingTokens } =
    useProviderTokensAndSyncedProviders({ fiscalYearId });

  // A GitHub App row is armed PENDING before the user ever reaches GitHub, so its mere existence
  // does not mean the provider is connected.
  const connectTicketingProviderComplete = Boolean(ticketingTokens?.some(isTicketingTokenConnected));
  const companyInfoComplete = Boolean(elevatorPitch?.length) && fiscalYearEndMonth !== null;
  const canStartAnalysis = connectTicketingProviderComplete && companyInfoComplete;
  const loading = isUseCurrentCompanyLoading || isUseProviderTokensAndSyncedProvidersLoading;

  return {
    connectTicketingProviderComplete,
    companyInfoComplete,
    canStartAnalysis,
    loading,
  };
};
